<template>
  <div class="outer-wrapper">
    <div class="title">
      <p>磁粉检测报告</p>
    </div>
    <Tabs>
      <TabPane label="待出具报告" icon="logo-buffer">
        <simple-list
          :columnsFormatData="reportPrepare"
          askData="mtReportPrepare"
          :refreshData="update_count"
          main_width="1280px"
        ></simple-list>
      </TabPane>
      <TabPane label="已出具报告" icon="logo-buffer">
        <report-list
          :columnsFormatData="reportAlready"
          askData="mtReportAlready"
          :refreshData="update_count"
          main_width="1280px"
        ></report-list>
      </TabPane>
    </Tabs>
    <Modal v-model="modalValue.confirm" :width="600" :mask-closable="false" :closable="false">
      <p slot="header" class="sc-header">
        <Icon type="ios-list-box" />
        <span>出具报告</span>
      </p>
      <div class="sc-content-wrapper">
        <div class="inner-content-wrapper">
          <table class="cr-form">
            <tr>
              <td>编号：</td>
              <td>
                <input type="text" placeholder v-model="item.pronumRange" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>报告日期：</td>
              <td>
                <input type="date" placeholder v-model="item.reportDate" style="width:200px;" />
              </td>
            </tr>
            <tr>
              <td>备注：</td>
              <td>
                <input type="text" placeholder v-model="item.remark" style="width:200px;" />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="doReport()">提交</Button>
        <Button size="large" @click="closeModal('confirm')">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import reportList from "@/components/Common/ReportList.vue";
import simpleList from "@/components/Common/SimpleList.vue";
let authData = JSON.parse(localStorage.getItem("authData"));
let userToken = localStorage.getItem("current_user_token");
//import shellExpand from "./ShellExpand.vue";

function itemValue() {
  return {
    pronumRange: "",
    reportDate: null,
    remark: ""
  };
}

export default {
  name: "mtReport",
  props: [],
  components: {
    reportList,
    simpleList
  },
  data() {
    return {
      op_name: this.$options.name,
      update_count: 0,
      modalValue: {
        confirm: false
      },
      item: itemValue(),
      reportPrepare: [
        /*{
            type: 'expand',
            width: 30,
            render: (h, params) => {
                return h(shellExpand, {
                    props: {
                        row: params.row
                    }
                })
            }
        },*/
        {
          title: "编号",
          key: "pronumRange",
          align: "center"
        },
        {
          title: "默认出具日期",
          key: "defaultdate",
          width: 150,
          align: "center"
        },
        {
          title: "操作",
          align: "center",
          width: 260,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { marginRight: "5px", color: "green" },
                  on: {
                    click: () => {
                      this.item.pronumRange = params.row.pronumRange;
                      this.item.reportDate = params.row.defaultdate;
                      this.openModal("confirm");
                    }
                  }
                },
                "出具"
              )
              /*h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "red" },
                  on: {
                    click: () => {
                      this.confirmBox(params.row);
                    }
                  }
                },
                "删除"
              )*/
            ]);
          }
        }
      ],
      reportAlready: [
        {
          title: "报告编号",
          key: "display_no",
          align: "center"
        },
        {
          title: "工件编号",
          key: "pronumRange",
          align: "center"
        },
        {
          title: "出具日期",
          key: "file_date",
          width: 100,
          align: "center"
        },
        {
          title: "文件",
          align: "center",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "green",marginRight:'5px' },
                  on: {
                    click: () => {
                      window.open('/archive/mtReport/'+params.row.id,"_blank");
                    }
                  }
                },
                "查看"
              ),
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "red" },
                  on: {
                    click: () => {
                      this.confirmBox(params.row);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ]
    };
  },
  computed: {},
  methods: {
    linkTo(url) {
      window.open(this.$fileUrlFac(url, authData.sfileRight));
    },
    openModal(value) {
      this.modalValue[value] = true;
    },
    closeModal(value) {
      this.modalValue[value] = false;
    },
    confirmBox(value) {
      this.$Modal.confirm({
        title: "确认删除：",
        content:
          "<p>" +
          "报告：" +
          value.display_no +          
          "</p>",
        onOk: () => {
          this.recordFormatDel(value.id);
        },
        onCancel: () => {}
      });
    },
    recordFormatDel(id) {
      this.$axios
        .post(this.$url + "/report", {
          userToken: userToken,
          askData: "delReport",
          id: id
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.$Message.success("删除成功！");
            this.update_count++;
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    doReport() {
      this.$axios
        .post(this.$url + "/report", {
          userToken: userToken,
          askData: "mtCreate",
          item: this.item
        })
        .then(response => {
          if (response.data.stat == "ok") {
            window.open('/archive/mtReport/'+response.data.fid,"_blank");
            this.closeModal("confirm");
            this.update_count++;
          } else {
            this.closeModal("confirm");
            this.$Message.error(response.data.data.info);
          }
        })
        .catch(error => {
          this.$Message.error("网络连接有误！" + error);
        });
    }
  }
};
</script>
<style scoped>
.outer-wrapper {
  width: 1280px;
  margin: 0 auto;
}
.title {
  text-align: center;
  margin: 10px auto;
  font-size: 20px;
}
.cr-form {
  width: 100%;
  border-collapse: collapse;
}

.cr-form td {
  height: 45px;
}

.cr-form td:first-child {
  text-align: right;
}

.cr-form input {
  padding: 0 10px;
  outline: none;
  height: 30px;
  border-radius: 2px;
  border: 1px solid #aaa;
}
</style>